'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFundDataAndAEMDocuments = exports.getFundDataAndOWCSDocuments = undefined;

var _funds_service = require('../services/funds_service.js');

var _funds_service2 = _interopRequireDefault(_funds_service);

var _funds_state = require('./funds_state.js');

var _funds_state2 = _interopRequireDefault(_funds_state);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _ramda = require('ramda');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FundsRepository = {
  getFundData: function getFundData(userLoggedIn, cusip, country, lang, role, productDataServiceUrl) {
    var owcsContent = {
      documentsData: {},
      fundContent: {}
    };
    var promiseForFundData = _funds_service2.default.getUSFundData(userLoggedIn, cusip, country, role, lang, productDataServiceUrl);

    return _jquery2.default.when(promiseForFundData).then(function (productDetail) {
      return _funds_state2.default.createFreshStateFromFund(cusip, country, productDetail, null, owcsContent, false);
    });
  },
  getFundDataAndOWCSDocuments: function getFundDataAndOWCSDocuments(userLoggedIn, cusip, country, lang, role, productDataServiceUrl, owcsServiceUrl) {
    var promiseForFundData = _funds_service2.default.getUSFundData(userLoggedIn, cusip, country, role, lang, productDataServiceUrl);

    var promiseForOWCSData = _funds_service2.default.getOWCSData(userLoggedIn, cusip, country, lang, role, owcsServiceUrl);

    return _jquery2.default.when(promiseForFundData, promiseForOWCSData).then(function (productDetail, owcsContent) {
      return _funds_state2.default.createFreshStateFromFund(cusip, country, productDetail, null, owcsContent, true);
    });
  },
  getFundDataAndAEMDocuments: function getFundDataAndAEMDocuments(userLoggedIn, cusip, country, lang, role, productDataServiceUrl, aemDocumentServiceUrl) {
    var accessCode = _jsCookie2.default.get("accessCode");

    var promiseForFundData = _funds_service2.default.getUSFundData(userLoggedIn, cusip, country, role, lang, productDataServiceUrl);

    var encodedAccessCode = !(0, _ramda.isNil)(accessCode) ? encodeURIComponent(accessCode) : accessCode;
    var promiseForDocumentData = _funds_service2.default.getDocumentData(country, encodedAccessCode, aemDocumentServiceUrl);

    return _jquery2.default.when(promiseForFundData, promiseForDocumentData).then(function (productDetail, documentContent) {
      var docContent = {
        documentsData: documentContent ? documentContent : {},
        fundContent: {}
      };
      return _funds_state2.default.createFreshStateFromFund(cusip, country, productDetail, null, docContent, true);
    });
  },
  getICLiteAutoCompleteData: function getICLiteAutoCompleteData(query, country, lang, currencyCode, icAutocompleteUrl) {
    var promise = _funds_service2.default.getICAutocompleteData(query, icAutocompleteUrl);

    return _jquery2.default.when(promise).then(function (data) {
      return data;
    });
  },
  getICLiteProductData: function getICLiteProductData(country, lang, role, currencyCode, icServiceUrl) {
    var figiIDs = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
    var growthOf10KFromDate = arguments[6];

    var promise = _funds_service2.default.getICFundData(figiIDs, country, lang, role, currencyCode, icServiceUrl, growthOf10KFromDate);

    return _jquery2.default.when(promise).then(function (data) {
      return data;
    });
  },
  getInvestmentComparisonData: function getInvestmentComparisonData(ticker, country, lang, role, currencyCode, icServiceUrl, icAutocompleteUrl) {
    var figiIDs = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];

    var promiseForICAutoCompleteData = _funds_service2.default.getICAutocompleteData(ticker, icAutocompleteUrl);

    return _jquery2.default.when(promiseForICAutoCompleteData).then(function (icAutocomplete) {
      var figiID = icAutocomplete[0].figiId;
      figiIDs.push(figiID);
      var promiseForICFundData = _funds_service2.default.getICFundData(figiIDs, country, lang, role, currencyCode, icServiceUrl);
      return _jquery2.default.when(promiseForICFundData).then(function (icFundData) {
        return icFundData;
      });
    });
  }
};

exports.default = FundsRepository;
var getFundDataAndOWCSDocuments = FundsRepository.getFundDataAndOWCSDocuments,
    getFundDataAndAEMDocuments = FundsRepository.getFundDataAndAEMDocuments;
exports.getFundDataAndOWCSDocuments = getFundDataAndOWCSDocuments;
exports.getFundDataAndAEMDocuments = getFundDataAndAEMDocuments;